import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { decodeJwt } from "./jwt";

export interface LoginState {
    user: string | null;
    token: string | null;
}

const initialState: LoginState = {
    user: null,
    token: null
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        login: (state, action: PayloadAction<string>) => {
            const token = action.payload;
            const claims = decodeJwt(token);
            state.user = claims?.user ?? claims?.username ?? null;
            state.token = token;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
        }
    }
});

export const { login, logout } = loginSlice.actions;

export const userLoggedIn = (state: RootState) => state.login.token !== null;

export const currentToken = (state: RootState) => state.login.token;

export const currentUser = (state: RootState) => state.login.user;

export default loginSlice.reducer;